import { topicsData, rankingData, featuresData, appData, mediaData } from '@/mocks/home';

export function TopicsSection() {
  return (
    <section id='topics' className='py-10 md:py-16 px-4 md:px-6 bg-background-50'>
      <div className='w-full max-w-5xl mx-auto'>
        <h2 className='font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2 text-center'>
          话题热榜
        </h2>
        <p className='text-sm text-foreground-500 text-center mb-6 md:mb-10'>
          综艺热议话题 · 大家都在聊
        </p>
        <div className='flex flex-wrap justify-center gap-2 md:gap-3'>
          {topicsData.map((topic, idx) => {
            const colors = [
              'bg-accent-100 text-accent-700',
              'bg-primary-100 text-primary-700',
              'bg-secondary-100 text-secondary-700',
              'bg-primary-100 text-primary-700',
              'bg-accent-100 text-accent-700',
              'bg-secondary-100 text-secondary-700',
              'bg-primary-100 text-primary-700',
              'bg-accent-100 text-accent-700',
              'bg-secondary-100 text-secondary-700',
            ];
            return (
              <div
                key={topic.name}
                className={`inline-flex items-center gap-2 px-3 md:px-4 py-2 md:py-2.5 rounded-full ${colors[idx]} cursor-pointer hover:opacity-80 transition-opacity`}
              >
                <span className='text-xs md:text-sm font-medium whitespace-nowrap'>{topic.name}</span>
                <span className='text-[10px] md:text-xs opacity-70 whitespace-nowrap'>{topic.count}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export function RankingSection() {
  return (
    <section id='ranking' className='py-10 md:py-16 px-4 md:px-6 bg-background-100'>
      <div className='w-full max-w-4xl mx-auto'>
        <h2 className='font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2 text-center'>
          综艺排行
        </h2>
        <p className='text-sm text-foreground-500 text-center mb-6 md:mb-10'>
          热门综艺实时排行 · 追综风向标
        </p>
        <div className='bg-background-50 rounded-xl overflow-hidden'>
          {rankingData.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3 md:py-4 ${
                idx < rankingData.length - 1 ? 'border-b border-background-100' : ''
              } hover:bg-background-50 transition-colors cursor-pointer`}
            >
              <div className={`w-8 h-8 md:w-9 md:h-9 rounded-lg flex items-center justify-center font-heading font-bold text-sm md:text-base flex-shrink-0 ${
                item.rank === 1 ? 'bg-accent-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className='flex-1 min-w-0'>
                <div className='flex items-center gap-2'>
                  <h3 className='font-heading text-sm md:text-base font-bold text-foreground-900'>{item.title}</h3>
                  <span className='px-2 py-0.5 rounded bg-background-100 text-foreground-500 text-xs whitespace-nowrap'>{item.tag}</span>
                </div>
              </div>
              <div className='flex items-center gap-2 flex-shrink-0'>
                <span className='text-xs md:text-sm text-foreground-600 font-medium whitespace-nowrap'>{item.heat}</span>
                {item.trend === 'up' && <i className='ri-arrow-up-line text-accent-500 text-sm'></i>}
                {item.trend === 'down' && <i className='ri-arrow-down-line text-foreground-400 text-sm'></i>}
                {item.trend === 'stable' && <i className='ri-subtract-line text-foreground-400 text-sm'></i>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function FeaturesSection() {
  return (
    <section id='features' className='py-10 md:py-16 px-4 md:px-6 bg-background-50'>
      <div className='w-full max-w-6xl mx-auto'>
        <h2 className='font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2 text-center'>
          平台特色
        </h2>
        <p className='text-sm text-foreground-500 text-center mb-6 md:mb-10'>
          为什么选择97在线影院 · 五大优势
        </p>
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5'>
          {featuresData.map((feature) => (
            <div
              key={feature.title}
              className='flex flex-col items-center text-center p-5 md:p-6 bg-background-100 rounded-xl hover:bg-background-200 transition-colors group'
            >
              <div className='w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-100 flex items-center justify-center mb-3 md:mb-4 group-hover:bg-primary-200 transition-colors'>
                <i className={`${feature.icon} text-primary-600 text-2xl md:text-3xl`}></i>
              </div>
              <h3 className='font-heading text-sm md:text-base font-bold text-foreground-900 mb-2'>{feature.title}</h3>
              <p className='text-xs md:text-sm text-foreground-600 leading-relaxed'>
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function AppSection() {
  return (
    <section id='app' className='py-10 md:py-16 px-4 md:px-6 bg-background-100'>
      <div className='w-full max-w-4xl mx-auto'>
        <h2 className='font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2 text-center'>
          移动观看
        </h2>
        <p className='text-sm text-foreground-500 text-center mb-6 md:mb-10'>
          随时随地 · 综艺随心看
        </p>
        <div className='flex flex-col lg:flex-row items-center gap-6 md:gap-10 bg-background-50 rounded-2xl p-6 md:p-10'>
          <div className='flex-shrink-0'>
            <div className='w-24 h-24 md:w-32 md:h-32 rounded-2xl bg-primary-100 flex items-center justify-center'>
              <i className='ri-smartphone-line text-primary-600 text-4xl md:text-5xl'></i>
            </div>
          </div>
          <div className='flex-1 text-center lg:text-left'>
            <h3 className='font-heading text-lg md:text-xl font-bold text-foreground-900 mb-3'>
              {appData.title}
            </h3>
            <p className='text-sm md:text-base text-foreground-600 leading-relaxed mb-4'>
              {appData.description}
            </p>
            <div className='flex flex-wrap justify-center lg:justify-start gap-2'>
              {appData.features.map((f) => (
                <span key={f} className='px-3 py-1.5 rounded-full bg-primary-50 text-primary-700 text-xs font-medium whitespace-nowrap'>
                  {f}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function MediaSection() {
  return (
    <section id='media' className='py-10 md:py-16 px-4 md:px-6 bg-background-50'>
      <div className='w-full max-w-6xl mx-auto'>
        <h2 className='font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2 text-center'>
          精彩预告
        </h2>
        <p className='text-sm text-foreground-500 text-center mb-6 md:mb-10'>
          精选综艺花絮与预告 · 先睹为快
        </p>
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5'>
          {mediaData.map((item) => (
            <div
              key={item.title}
              className='group bg-background-100 rounded-xl overflow-hidden cursor-pointer hover:scale-[1.02] transition-all duration-300'
            >
              <div className='relative w-full aspect-[16/10] overflow-hidden bg-background-200'>
                <img
                  src={item.image}
                  alt={item.title}
                  className='w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500'
                />
                <div className='absolute inset-0 flex items-center justify-center'>
                  <div className='w-12 h-12 md:w-14 md:h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform'>
                    <i className='ri-play-fill text-primary-500 text-xl md:text-2xl'></i>
                  </div>
                </div>
                <span className='absolute top-2 right-2 px-2 py-0.5 rounded bg-background-50/90 text-foreground-700 text-xs font-medium whitespace-nowrap'>
                  {item.tag}
                </span>
              </div>
              <div className='p-3 md:p-4'>
                <h3 className='font-heading text-sm md:text-base font-bold text-foreground-900 mb-1 line-clamp-2'>
                  {item.title}
                </h3>
                <p className='text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2'>
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}